import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { setUrls } from '../../redux/slices/chatbotSlice';

const DragAndDrop = ({ triggerNextStep }) => {
  const [files, setFiles] = useState(null);
  const inputRef = useRef();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDragOver = e => {
    e.preventDefault();
  };

  const handleDrop = e => {
    e.preventDefault();
    console.log(e.dataTransfer.files);
    setFiles(e.dataTransfer.files);
  };

  const handleInputChange = e => {
    setFiles(e.target.files);
    console.log(e.target.files[0]);
  };

  useEffect(() => {
    if (files) {
      dispatch(setUrls(files));
      triggerNextStep({ trigger: '6' });
    }
  }, [files]);

  return (
    <>
      {!files ? (
        <div className="dragAndDrop" onDragOver={handleDragOver} onDrop={handleDrop}>
          <p>{t('botDragAndDrop')}</p>
          <p>{t('botOr')}</p>
          <input ref={inputRef} type="file" multiple onChange={handleInputChange} hidden></input>
          <button onClick={() => inputRef.current.click()}>{t('botUploadFiles')}</button>
        </div>
      ) : (
        <div>{t('botThanksUpload')}</div>
      )}
    </>
  );
};

export default DragAndDrop;
